module.exports = __webpack_public_path__ + "img/expert-4.87b69568.png";